import gemmaPic from "@/public/images/artists/gemma.png";
import { Artist } from "@/types/types";

export const gemma = {
  id: "267",
  name: "Gemma",
  image: gemmaPic,
  description: `Gemma's voice is deep and smoky, with a warm, resonant weight that feels instantly recognizable. The subtle African accent in her tone adds extra character to its grainy, soulful quality, fitting seamlessly into Afrobeats, R&B, and alternative soul.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fgemma-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Unprocessed", "Afrobeat", "RnB", "Soul"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 55,
        high: 69,
      },
      sweetSpot: 62,
    },
  },
} as const satisfies Artist;
